import { featureFlags } from "@environments/environment";

export interface RetentionPolicyInfo {
  expirationMonths: number;
  thresholdDays: number;
}

export const RetentionPolicyConstants =
  ['FILE', 'CHAT', 'CHAT_DELETED_AGENT', 'PRIVATE_AGENT', 'SHARED_AGENT', 'PUBLIC_AGENT', 'PUBLIC_PROMPT', 'PRIVATE_PROMPT'] as const

export type RetentionPolicy = typeof RetentionPolicyConstants[number]

export const RetentionPolicyDetails: Record<RetentionPolicy, RetentionPolicyInfo> = {
  FILE: { expirationMonths: 12, thresholdDays: 30 } as const,
  CHAT: { expirationMonths: 12, thresholdDays: 30 } as const,
  CHAT_DELETED_AGENT: { expirationMonths: 1, thresholdDays: 30 } as const,
  SHARED_AGENT: { expirationMonths: 12, thresholdDays: 30 } as const,
  get PRIVATE_AGENT() {
    return { expirationMonths: featureFlags.newAgentRetentionPolicy ? 6 : 12, thresholdDays: 30 }
  },
  get PUBLIC_AGENT() {
    return {expirationMonths: featureFlags.newAgentRetentionPolicy ? 3 : 6, thresholdDays : 30 }
  },
  PUBLIC_PROMPT: { expirationMonths: 12, thresholdDays: 30 } as const,
  PRIVATE_PROMPT: { expirationMonths: 6, thresholdDays: 30 } as const,
};

export interface RetentionPolicyChip {
  date: Date;
  type: RetentionPolicy;
  nonExpiringText?: string;
  expirationDate?: Date;
}

export const RetentionPolicyUtils = {
  isExpiringSoon(expirationDate: Date, threshold: Date): boolean {
    return expirationDate.getTime() <= threshold.getTime();
  },

  isExpired(expirationDate: Date, currentDate: Date): boolean {
    if (expirationDate.getDay() === 0) {
      return currentDate >= expirationDate;
    }
    let currentDateMidDay = this.getDateMidDay(currentDate)
    let expirationDateMidDay = this.getDateMidDay(expirationDate);
    return currentDateMidDay > expirationDateMidDay;
  },

  getToday(): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  },

  getDateMidDay(date: Date): Date {
    date.setHours(12, 0, 0, 0);
    return date;
  },

  getExpirationDate(inputDate: Date, expirationMonths: number): Date {
    const expirationDateMidDay = new Date(this.getDateMidDay(inputDate));
    expirationDateMidDay.setMonth(expirationDateMidDay.getMonth() + expirationMonths);
    return expirationDateMidDay;
  }
};
